import ExcelJS from "exceljs";

export async function downloadRowsAsXlsx({ filename, sheetName = "Report", title, subtitleRows = [], headers, rows, totalRow }) {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Ebek One";
  const sheet = workbook.addWorksheet(String(sheetName).slice(0, 31));
  if (title) sheet.addRow([title]);
  subtitleRows.filter(Boolean).forEach(text => sheet.addRow([text]));
  if (title || subtitleRows.length) sheet.addRow([]);
  const headerRow = sheet.addRow(headers);
  headerRow.eachCell(cell => {
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF0F766E" } };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
  });
  rows.forEach(row => sheet.addRow(row));
  if (totalRow) { sheet.addRow([]); const row = sheet.addRow(totalRow); row.font = { bold: true }; }
  const width = Math.max(headers.length, ...rows.map(row => row.length), totalRow?.length || 0);
  sheet.columns = Array.from({ length: width }, (_, col) => ({
    width: Math.min(42, Math.max(12, [headers[col], ...rows.slice(0, 200).map(row => row[col]), totalRow?.[col]]
      .reduce((max, value) => Math.max(max, String(value ?? "").length), 0) + 2)),
  }));
  sheet.views = [{ state: "frozen", ySplit: headerRow.number, activeCell: `A${headerRow.number + 1}` }];
  sheet.autoFilter = { from: { row: headerRow.number, column: 1 }, to: { row: headerRow.number, column: headers.length } };
  sheet.eachRow((row, rowNumber) => { if (rowNumber > headerRow.number) row.alignment = { vertical: "top", wrapText: true }; });
  const buffer = await workbook.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
  const link = document.createElement("a");
  link.href = url; link.download = String(filename).replace(/\.(csv|xls)$/i, ".xlsx");
  document.body.appendChild(link); link.click(); link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
